export type Features = {
	allowExactOrderDeliveryLocation: boolean
	allowKlarnaIntegration: boolean
	allowSettingConsumerGroupConnections: boolean
	allowUserInvitesToBeSentWithSms: boolean
	consumerSelfRegistrationSettings: ConsumerSelfRegistrationSettings
	discountCodeMode: DiscountCodeMode
	googleTagManagerMode: GoogleTagManagerMode
	notificationsEnabled: boolean
	orderActivityRenderMode: OrderActivityRenderMode
	orderDetailsRenderMode: OrderDetailsRenderMode
	orderUIProductImagesWithLogos: boolean
	orderUIShowSidebar: boolean
	orderUiAllowAnonymousOrders: boolean
	orderUiAllowLoggingIn: boolean
	orderUiAllowUploadingOrderImages: boolean
	orderUiLoginPlacement: OrderUILoginPlacement
	orderUiOrderReferencesMode: OrderReferenceMode
	orderUiProductSelectionMode: ProductSelectionMode
	orderUiRenderTransportZones: boolean
	pwaDisplay: string
}

export enum OrderDetailsRenderMode {
	Modal = "Modal",
	FullPage = "FullPage",
}

export enum GoogleTagManagerMode {
	Disabled = "Disabled",
	Enabled = "Enabled",
}

export enum OrderUILoginPlacement {
	Hide = "Hide",
	HeaderRight = "HeaderRight",
	SideMenuBottom = "SideMenuBottom",
}

export enum OrderActivityRenderMode {
	NoRender = "NoRender",
	WithoutChat = "WithoutChat",
	WithChat = "WithChat",
}

export enum OrderReferenceMode {
	Hide = "Hide",
	ShowExternalReference = "ShowExternalReference",
}

export enum DiscountCodeMode {
	Hide = "Hide",
	AllowEntry = "AllowEntry",
	//AllowCreation = "AllowCreation",
}

export enum ProductSelectionMode {
	Modal = "Modal",
	FullPage = "FullPage",
}

export enum ConsumerSelfRegistrationMode {
	AllowCreateDirect = "AllowCreateDirect",
	AllowCreatePending = "AllowCreatePending",
	Deny = "Deny",
}

export type ConsumerSelfRegistrationSettings = {
	mode: ConsumerSelfRegistrationMode
}
